import type { DateTime } from "luxon";

export interface AnimalMeta {
  [key: string]: string | DateTime | boolean | number | undefined;
}

export interface IAnimal {
  id: number;
  name: string;
  customerId?: number;
  animalType?: string;
  avmaskad?: DateTime;
  meta?: AnimalMeta;
}

export type Animal = Readonly<IAnimal>;

export interface SourceAnimal {
  id: number;
  animalId: number;
  name?: string;
  birthyear?: number;
  avmaskad?: DateTime;
  avmaskmedel?: string;
  source: "portal";
}

export function readAnimalMeta<K extends keyof AnimalMeta>(
  animal: Animal,
  key: K,
): AnimalMeta[K] {
  return animal.meta?.[key];
}
